module.exports = __webpack_public_path__ + "media/assets/instagram.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/instagram.svg
// module id = 30
// module chunks = 0